import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IUserPage, IUserPagesResponse } from '../../views/pages/main/store/model'

interface PagesState {
  userPages: IUserPage[]
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
  lastFetchedAt: number | null // Son veri çekme zamanını tutacak
}

const initialState: PagesState = {
  userPages: [],
  status: 'idle',
  error: null,
  lastFetchedAt: null
}

const pagesSlice = createSlice({
  name: 'pages',
  initialState,
  reducers: {
    setUserPages: (state, action: PayloadAction<IUserPagesResponse>) => {
      // API'den gelen veriyi kontrol et ve işle
      if (action.payload) {
        if (action.payload.status === 'success' && Array.isArray(action.payload.data)) {
          state.userPages = action.payload.data;
          state.status = 'succeeded';
          state.lastFetchedAt = Date.now();
          state.error = null;
          
          // Sayfalar yüklendiğinde localStorage'a işaret koy
          if (state.userPages.length > 0) {
            localStorage.setItem('shouldOpenDashboardMenu', 'true');
          }
        } else if (Array.isArray(action.payload.data)) {
          // Alternatif veri yapısı
          state.userPages = action.payload.data;
          state.status = 'succeeded';
          state.lastFetchedAt = Date.now();
          state.error = null;
          
          if (state.userPages.length > 0) {
            localStorage.setItem('shouldOpenDashboardMenu', 'true');
          }
        } else {
          console.error('setUserPages: Geçersiz veri yapısı', action.payload);
          state.userPages = [];
          state.status = 'failed';
          state.error = 'Veri alınamadı veya geçersiz format';
          state.lastFetchedAt = null;
        }
      } else {
        state.userPages = [];
        state.status = 'failed';
        state.error = 'Veri alınamadı';
        state.lastFetchedAt = null;
      }
    },
    setLoading: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.status = 'failed';
      state.error = action.payload;
      state.lastFetchedAt = null;
    },
    clearPages: (state) => {
      state.userPages = [];
      state.status = 'idle';
      state.error = null;
      state.lastFetchedAt = null;
      localStorage.removeItem('shouldOpenDashboardMenu');
    },
    // Yeni reducer: Belirli bir sayfayı güncelle
    updatePage: (state, action: PayloadAction<{ pageId: number; data: any }>) => {
      const index = state.userPages.findIndex(page => page.ID === action.payload.pageId);
      if (index !== -1) {
        state.userPages[index] = { ...state.userPages[index], ...action.payload.data };
      }
    }
  }
})

export const { setUserPages, setLoading, setError, clearPages, updatePage } = pagesSlice.actions
export default pagesSlice.reducer 